import { httpRequest } from "@services/http";
import { AudienceDefinition } from "@models/audienceDefinition.model";
import { AudienceDefinitionSerializer } from "@models/serializers/audienceDefinitionSerializer";

// Audiences belong to the engagement, so the list is not scoped to a campaign.
export class CommandGetEngagementAudiences {
  async run(engagementId: number): Promise<AudienceDefinition[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/audiences/`;
    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });

    const serializer = new AudienceDefinitionSerializer();
    return serializer.deserializeList(response);
  }
}